// extracted by mini-css-extract-plugin
export default {"container":"_98_Guide_container__uqSjo"};